import Observer from 'common/scripts/observer';

const observer = new Observer();
// Для удаления обработчиков событий храним ноду не в классе.
const page = $('html, body');

class ScrollBy {
    init(options = {}) {
        const defSpeedAnimation = 1000;
        const defaultOffset = 0;

        this.options = options;
        this.options.anchors = options.anchors || [];
        this.options.offset = options.offset || defaultOffset;
        this.options.animate = options.animate !== false;
        this.options.speedAnimation = options.speedAnimation || defSpeedAnimation;
        this.options.takeElements = options.takeElements || [];
        this.offset = this.options.offset;

        this._initAnchors();
    }

    /**
     * Метод скроллит по клику на кнопку с указаными в дата атрибуте id элемента, к которому нужно проскролить
     * @param {object} element - дом-элемент с которого ловится клик
     * @public
     */
    scrollToHref(element) {
        element.addEventListener('click', (event) => {
            event.preventDefault();

            const id = element.dataset.scrollBy || element.getAttribute('href');
            const target = document.querySelector(id);

            this._setActiveClass(element);
            this._setOffsetTakeElements();
            this._scroll(target);
            this._setGetParams(id);
        });
    }

    /**
     * Метод скролит к дом элементу
     * @param {object} element - дом-элемент к которому необходимо проскролить
     * @public
     */
    scrollToElement(element) {
        this._scroll(element);
    }

    /**
     * Метод скролит к якорю из гет-параметра
     * @public
     */
    scrollToGetAnchor() {
        this._parseGetParams();
    }

    /**
     * Метод скролит наверх страницы
     * @public
     */
    scrollToTop() {
        this._scroll();
    }

    /**
     * Метод навешивает обработчики событий
     * @private
     */
    _bindEvents() {
        window.addEventListener('mousewheel', this._scrollStop);

        window.addEventListener('touchstart', this._scrollStop);
    }

    /**
     * Метод удаляет обработчики событий
     * @private
     */
    _removeBindEvents() {
        window.removeEventListener('mousewheel', this._scrollStop);

        window.removeEventListener('touchstart', this._scrollStop);
    }

    /**
     * Метод инициализирует якоря из массива.
     * @private
     */
    _initAnchors() {
        this.options.anchors.forEach((item) => {
            this.scrollToHref(item);
        });
    }

    /**
     * Метод выполняет анимацию скрола
     * @param {object} element - дом-элемент к которому необходимо проскролить
     * @private
     */
    _scroll(element = false) {
        const x = 0;
        const y = element ? (element.getBoundingClientRect().top + pageYOffset) - this.offset : 0;

        observer.publish('scrollbyStart');

        if (this.options.animate) {
            page.animate({scrollTop: y}, this.options.speedAnimation);

            setTimeout(() => {
                observer.publish('scrollbyFinish');

                this._removeBindEvents();
            }, this.options.speedAnimation);
        }

        if (!this.options.animate) {
            window.scrollTo(x, y);
        }

        this._bindEvents();
    }

    /**
     * Метод останавливает скролл
     * @private
     */
    _scrollStop() {
        page.stop();
    }

    /**
     * Метод парсит гет-параметры
     * @private
     */
    _parseGetParams() {
        const get = window.location.search;

        if (get) {
            const url = new URLSearchParams(get);

            for (const item of url.entries()) {
                if (item[0] === 'anchor') {
                    const element = document.querySelector(`#${item[1]}`);

                    this._scroll(element);
                }
            }
        }
    }

    /**
     * Устанавливает отступ в зависимости от высоты переданного элемента и дополнительной настройки
     * @private
     */
    _setOffsetTakeElements() {
        const takeElements = this.options.takeElements;

        if (takeElements.length) {
            let sum = 0;

            takeElements.forEach((item) => {
                if (item) {
                    sum = sum + item.offsetHeight;
                }
            });

            this.offset = -this.options.offset + sum;
        }
    }

    /**
     * Устанавливает активный класс для якоря
     * @param {object} element - дом-элемент по которому произошел клик
     * @private
     */
    _setActiveClass(element) {
        this.options.anchors.forEach((item) => {
            item.classList.remove('is-active');
        });

        element.classList.add('is-active');
    }

    /**
     * Устанавливает id якоря как гет-параметр
     * @param {id} id - id якоря
     * @private
     */
    _setGetParams(id) {
        document.location.hash = id;
    }
}

export default ScrollBy;
